import { css } from 'styled-components'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { useAppRoutes } from '@root/features/routing'

import type { OrderTableColumn } from '../atoms'
import type { OrderModel } from '@root/entities/order/atoms'
import type { ClassNameProps } from '@root/shared/react'
import type { DataTableModel } from '@root/shared/ui-kit'

type Props = {
  withCurrency?: boolean
  tableModel: DataTableModel<OrderModel, OrderTableColumn, object, undefined>
  clickable?: boolean
} & ClassNameProps

export const OrdersTable: React.FC<Props> = ({
  className,
  tableModel,
  clickable = true,
}) => {
  const { navigateToTrading } = useAppRoutes()

  const handleRowClick = (value: OrderModel) => {
    navigateToTrading(value.order.pair.address, value.order.pair.network)
  }

  return (
    <AppDataTable
      className={className}
      css={css`
        height: 100%;
      `}
      model={tableModel}
      rowHeight={40}
      onRowClick={clickable ? handleRowClick : undefined}
    />
  )
}
